import store from "../../redux/configureStore";
export const isMenuAllowed = (requiredPermissions) => {
    var _a;
    const state = store === null || store === void 0 ? void 0 : store.getState();
    const permissions = (_a = state === null || state === void 0 ? void 0 : state.context) === null || _a === void 0 ? void 0 : _a.companyPermissionDTOs;
    return ((permissions === null || permissions === void 0 ? void 0 : permissions.some((elm) => requiredPermissions.includes(elm.permission))) ||
        requiredPermissions.length === 0);
};
